import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActivationEnd, ActivationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, scan } from 'rxjs/operators';
import { ChargEyeLayoutRouteData } from './layout.models';

@Component({
    selector: 'ce-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
    isMobile$: Observable<boolean>;
    pageId$: Observable<string>;

    @Input() showGlobalLoading = false;
    @Input() showLayout = false;

    constructor(
        breakpoint: BreakpointObserver,
        private router: Router
    ) {
        this.isMobile$ = breakpoint.observe(Breakpoints.Handset).pipe(map((b) => b.matches));
        this.pageId$ = this.router.events.pipe(
            // Gather "page id" from applicable route data: { pageId: '' } and assign it to page's css class
            scan((acc, ev) => {
                if (ev instanceof ActivationStart) {
                    // new navigation - clear page id list
                    acc = [];
                } else if (ev instanceof ActivationEnd && ev.snapshot.component) {
                    const data = (ev as ActivationEnd).snapshot.data as ChargEyeLayoutRouteData;
                    // add to page id list if page id known in route data
                    if (data.pageId) {
                        acc = [...new Set([...acc, data.pageId])];
                    }
                }

                return acc;
            }, [] as string[]),
            // and separate by spaces for a css class list
            map((pageIds) => pageIds.join(' '))
        );
    }
}
